import { PushGADataLayer } from "../../utils/helpers";

const NavigationPanelItem = ({navItem}) => {
return(<div className="justify-start items-start gap-3 inline-flex">
    <img className="w-12 h-12 rounded-lg" src={navItem.innerNavImage} alt={navItem.innerNavTitle} loading="lazy"/>
    <div className="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
    <a href={navItem.innerNavTemplate} target={navItem.innerNavTarget ? "_blank" : navItem.innerNavTarget}  rel="noreferrer" onClick={() => PushGADataLayer('Navigations','Top Navigation',navItem.innerNavTitle)}>
        <div className="text-black text-sm xl:text-lg font-bold content-center h-12 mb-1">
            {navItem.innerNavTitle}
        </div>
    </a>
    {
        navItem.innerNavItems.length? 
        (
        <div className="flex-col justify-start items-start gap-2 flex">
            {navItem.innerNavItems.map((innerNavItem,index) =>
                <a key={`nav-item-${index}`} href={innerNavItem.innerNavSubTemplate} target={innerNavItem.innerNavSubTarget ? "_blank" : innerNavItem.innerNavSubTarget} rel="noreferrer"><div className="text-stone-500 text-sm font-normal" onClick={() => PushGADataLayer('Navigations','Top Navigation',innerNavItem.innerNavSubTitle)}>{innerNavItem.innerNavSubTitle}</div></a>
            )}
        </div>
        )
        :null
    }
    </div>
</div>);
}

export default NavigationPanelItem;